var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#6797B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3102 40.7468L22.923 26.0795C21.0781 25.3396 19.2502 24.6755 17.4334 23.9735C15.6167 23.2715 13.814 22.5948 12 21.9027C12.1601 21.6134 26.6955 7.56523 27.2107 7.2002L23.0381 18.0866C25.1679 18.8869 27.2711 19.631 29.3658 20.3962C31.4606 21.1614 33.5384 21.9153 35.6051 22.6678C35.6177 22.7156 35.6233 22.7282 35.6248 22.7408C35.6262 22.7539 35.6238 22.7671 35.6177 22.7787C35.5785 22.8329 35.5353 22.884 35.4886 22.9318C29.1239 28.8893 22.754 34.8455 16.379 40.8002L16.3102 40.7468Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b2656755415c572f306c407767fe902d.svg";
export { ForwardRef as ReactComponent };